module.exports = __webpack_public_path__ + "img/add-user-icon.0802a1a1.svg";